import React, { memo, useCallback, useEffect, useState } from 'react';
import './styles.scss';
import classNames from 'classnames';
import ArrowLongIcon from '../icons/ArrowLongIcon';

const PIXELS_FROM_TOP = 2500;

const ArrowIcon = <ArrowLongIcon />;

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisible = useCallback(() => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > PIXELS_FROM_TOP) {
      setIsVisible(true);
    } else if (scrolled <= PIXELS_FROM_TOP) {
      setIsVisible(false);
    }
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisible);

    return () => window.removeEventListener('scroll', toggleVisible);
  }, [toggleVisible]);

  return (
    <button
      onClick={scrollToTop}
      className={classNames('scroll-to-top-button', {
        'scroll-to-top-button__hide': !isVisible,
      })}
    >
      {ArrowIcon}
    </button>
  );
};

export default memo(ScrollToTopButton);
